/* eslint-disable max-len */
// ItemIds to test use cases
export const TOOL_ITEMID = '316821412'; // Carpet Cleaner
export const VEHICLE_ITEMID = '316821410'; // Load-N-Go Van
export const LARGE_EQUIP_ITEMID = '316821721'; // Mini Exavator

// Vehicle categories
export const VEHICLE_CATEGORIES = ['45', '65', '95'];
export const LARGE_EQUIP_CATEGORIES = ['33'];

// Blacklisted warning message
export const WARNING_MESSAGE = 'Due to demand, this unit is not available for online reservations. Call or visit the store to rent this unit.';

// StoreSearchServices
export const STORE_SEARCH_RADIUS = 200;
export const STORES_LIMIT = 30;

// API Constants
export const MAX_VANTAGE_RETRIES = 2;
export const INVENTORY_AVAILABILITY_URL = '/product-information/rental/inventory';
